import { useState, useEffect } from 'react';
import '../ordersCard.css';
import { doc, updateDoc } from 'firebase/firestore';
import { orderDb } from '../firebaseOrders';

const AdminOrderCard = ({ order, inventoryData, orderTotal }) => {
  const {
    id,
    orderNumber,
    confirmationNumber,
    shippingRate,
    items,
    customerDetails,
    shippingAddress,
    billingAddress,
    createdAt,
    custEmail,
    Status
  } = order;
const [tracking, setTracking] = useState(order.tracking || '');
const [trackingInput, setTrackingInput] = useState(order.tracking || '');

const [saved, setSaved] = useState(false);
const [reloadTrigger, setReloadTrigger] = useState(0);

  const formattedDate = createdAt?.toDate
    ? createdAt.toDate().toLocaleString()
    : new Date(createdAt).toLocaleString();

  const [openSections, setOpenSections] = useState({
    customerDetails: false,
    shippingAddress: false,
    billingAddress: false,
    items: false,
  });

  const [status, setStatus] = useState(Status);
  const [saving, setSaving] = useState(false);

  const toggleSection = (sectionName) => {
    setOpenSections((prev) => ({
      ...prev,
      [sectionName]: !prev[sectionName],
    }));
  };
useEffect(() => {
  // This can be used to trigger any side effects or data refresh logic
  // For example, if your parent component fetches orders again, you can call a prop function here
  console.log("Reloading order data...");
  // Optionally, you could call a function from props like props.reloadOrders?.()
}, [reloadTrigger]);

  const handleStatusChange = async (newStatus) => {
    setStatus(newStatus);
    setSaving(true);
    try {
      const orderRef = doc(orderDb, 'orders', id);
      await updateDoc(orderRef, { Status: newStatus });
      console.log('Status updated in Firestore');
    } catch (error) {
      console.error('Error updating status in Firestore:', error);
    } finally {
      setSaving(false);
    }
  };

  const [updatedItems, setUpdatedItems] = useState(items);

  const handleItemUpdate = (index, field, value) => {
    const newItems = [...updatedItems];
    newItems[index] = {
      ...newItems[index],
      [field]: isNaN(value) ? 0 : value,
    };
    setUpdatedItems(newItems);
  };

  const handleSaveItems = async () => {
    try {
      const orderRef = doc(orderDb, 'orders', id);
      await updateDoc(orderRef, { items: updatedItems });
      alert('Item updates saved!');
    } catch (error) {
      console.error('Failed to update items:', error);
      alert('Error saving item updates.');
    }
  };
const handleSaveTracking = async () => {
  if (!trackingInput) return;

  try {
    const orderRef = doc(orderDb, 'orders', id);
    await updateDoc(orderRef, { tracking: trackingInput });

    setTracking(trackingInput);        // Update the saved display state
    setTrackingInput('');              // Clear input field
    setSaved(true);
    setReloadTrigger(prev => prev + 1); // Optional, for parent updates
  } catch (error) {
    console.error('Error saving tracking number:', error);
    alert('Failed to save tracking number');
  }
};

const getTrackingUrl = (trackingNum) => {
  if (/^1Z/.test(trackingNum)) return `https://www.ups.com/track?tracknum=${trackingNum}`;
  if (/^\d{20,22}$/.test(trackingNum)) return `https://tools.usps.com/go/TrackConfirmAction?tLabels=${trackingNum}`;
  if (/^\d{12,15}$/.test(trackingNum)) return `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNum}`;
  return `https://www.ups.com/track?tracknum=${trackingNum}`;
};

  return (
    <div className="order-card">
      <div className="order-header">
        <h6>Order #{orderNumber}</h6>
        <h6>Confirmation: {confirmationNumber}</h6>
        <div className="status-control">
          <label htmlFor={`status-${orderNumber}`}><strong>Status:</strong></label>
          <select
          style={{marginLeft:10, marginBottom:10}}
            id={`status-${orderNumber}`}
            value={status}
            onChange={(e) => handleStatusChange(e.target.value)}
            disabled={saving}
          >
            <option value="Received">Received</option>
            <option value="In Production">In Production</option>
            <option value="Shipped">Shipped</option>
          </select>
          {saving && <span>Saving...</span>}
        </div>
{tracking && (
 <lable style={{ marginTop: 25 }}>
 <strong >
    Tracking#: <a href={getTrackingUrl(tracking)} target="_blank" rel="noopener noreferrer">{tracking}</a>
  </strong>
  </lable>
)}

{!tracking && (
  <div style={{ marginTop: 5 }}>
    <strong>Tracking#:</strong>
    <input
      style={{ marginLeft: 10 }}
      value={trackingInput}
      onChange={(e) => setTrackingInput(e.target.value)}
      placeholder="Tracking #"
    />
    <button onClick={handleSaveTracking} style={{ marginLeft: 10 }}>
      Save Tracking
    </button>
  </div>
)}








        {orderTotal && (
          <div className="section shipping-rate">
            <strong>Total:</strong> ${orderTotal}
          </div>
        )}
        <div className="order-date">Placed on {formattedDate}</div>
      </div>

      {[
        {
          label: 'Customer Details', key: 'customerDetails', content: (
            <>
              <p><strong>Name:</strong> {customerDetails?.name}</p>
              <p><strong>Email:</strong> {customerDetails?.email}</p>
              <p><strong>Phone:</strong> {customerDetails?.phone}</p>
            </>
          )
        },
        {
          label: 'Shipping Address', key: 'shippingAddress', content: (
            <address>
              {shippingAddress?.name}<br />
              {shippingAddress?.street1}<br />
              {shippingAddress?.street2 && (<>{shippingAddress.street2}<br /></>)}
              {shippingAddress?.city}, {shippingAddress?.state} {shippingAddress?.zip}<br />
              {shippingAddress?.country}
            </address>
          )
        },
        {
          label: 'Billing Address', key: 'billingAddress', content: (
            <address>
              {billingAddress?.name}<br />
              {billingAddress?.street1}<br />
              {billingAddress?.street2 && (<>{billingAddress.street2}<br /></>)}
              {billingAddress?.city}, {billingAddress?.state} {billingAddress?.zip}<br />
              {billingAddress?.country}
            </address>
          )
        },
      ].map(({ label, key, content }) => (
        <div className="section" key={key}>
          <h4 onClick={() => toggleSection(key)}>
            {label} {openSections[key] ? '▲' : '▼'}
          </h4>
          {openSections[key] && <div className="dropdown-content">{content}</div>}
        </div>
      ))}

      <div className="section">
        <h4 onClick={() => toggleSection('items')}>
          Items {openSections.items ? '▲' : '▼'}
        </h4>
        {openSections.items && (
          <div className="dropdown-content">
            <div className="table-wrapper">
              <table className="items-table">
                <thead>
                  <tr>
                    <th>Item</th>
                    <th>Image</th>
                    <th>Style</th>
                    <th>Color</th>
                    <th>Size</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Garment Price</th>       {/* NEW */}
                    <th>Image Price</th>         {/* NEW */}
                    <th>Image Size</th>
                    <th>Inventory</th>
                    <th>Actual Img $</th>
                    <th>Actual Garment $</th>
                    <th>Other $</th>
                    <th>Image Profit</th>
                    <th>Item Profit plus $3</th>
                  </tr>
                </thead>
                <tbody>
                  {updatedItems.map((item, i) => {
                    const id = `${item.style}-${item.color$API}-${item.size}`;
                    const inventory = inventoryData?.[id] || {};
                    const imagePrice = parseFloat(item.imagePrice || 0);
                    const garmentPrice = parseFloat(item.garmentPrice || 0);
                    const actualImagePrice = parseFloat(item.actualImagePrice || 0);
                    const actualGarmentPrice = parseFloat(item.actualGarmentPrice);
                    const otherCost = parseFloat(item.otherCost || 0);
                    const price = parseFloat(item.price || 0);
const tracking = (item.price || "N/A");
                    const imageProfit = imagePrice - actualImagePrice;
                    const costs = (actualGarmentPrice + actualImagePrice + otherCost)
                    const itemProfit = price - costs + 3;
                    // console.log(price, costs)
                    return (
                      <tr key={i}>
                        <td><img src={item.finalUrl} alt="" style={{ width: 80 }} /></td>
                        <td><img src={item.thumImage} alt="" style={{ width: 70 }} />ID: {item.thumId}</td>
                        <td>{item.style}</td>
                        <td>{item.color}</td>
                        <td>{item.size}</td>
                        <td>{item.quantity}</td>
                        <td>${price.toFixed(2)}</td>
                        <td>${garmentPrice.toFixed(2)}</td>
                        <td>${imagePrice.toFixed(2)}</td>
                        <td>{item.image_width2} x {item.image_height2}</td>
                        <td>
                          {Object.entries(inventory).map(([city, qty]) => (
                            <div key={city}>{city}: {qty}</div>
                          ))}
                        </td>
                        <td>
                          <input
                            type="number"
                            value={actualImagePrice}
                            onChange={(e) =>
                              handleItemUpdate(i, 'actualImagePrice', parseFloat(e.target.value))
                            }
                            placeholder="Actual Img $"
                            style={{ width: '80px' }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={actualGarmentPrice}
                            onChange={(e) =>
                              handleItemUpdate(i, 'actualGarmentPrice', parseFloat(e.target.value))
                            }
                            placeholder="Actual Garm $"
                            style={{ width: '80px' }}
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            value={otherCost}
                            onChange={(e) =>
                              handleItemUpdate(i, 'otherCost', parseFloat(e.target.value))
                            }
                            placeholder="Other $"
                            style={{ width: '80px' }}
                          />
                        </td>
                        <td>${imageProfit.toFixed(2)}</td>
                        <td>${itemProfit.toFixed(2)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <button onClick={handleSaveItems} style={{ marginTop: '1rem' }}>
                Save Item Updates
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="section shipping-rate">
        <strong>Shipping Rate:</strong> ${parseFloat(shippingRate).toFixed(2)} + $3 handling
      </div>
    </div>
  );
};

export default AdminOrderCard;
